const BatchSendUnit = {
  tableConfig: {
    // showCheckbox: true
  },
  queryList: [
    {
      name: 'schoolName',
      label: '单位名称',
      component: 'input'
    },
    {
      name: 'name',
      label: '联系人',
      component: 'input'
    }
  ],
  urlMap: {
    'select': {
      url: '/custom/sendPaper/canArrangeUnitList',
      data: {
        paperIds: '{parentId}'
      }
    },
    batchSendReview: '/custom/sendPaper/relateUnitSelected'
  },
  operList: [// 操作列表
  ],
  titles: [
    {
      name: 'schoolId',
      key: true
    },
    {
      name: 'schoolName',
      label: '单位名称'
    },
    {
      name: 'department',
      label: '学院名称'
    },
    {
      name: 'name',
      label: '联系人'
    },
    {
      name: 'mobile',
      label: '联系电话'
    },
    {
      name: 'operation',
      label: '操作',
      actionList: [
        {
          label: '指派',
          name: 'batchSend',
          kind: 'primary', // error
          type: 'request',
          method: 'post',
          data: {
            paperIdList: '("{parentId}").split(",")',
            receiveUnitUserId: '{userId}',
            extSendFlag: '0'
          },
          addr: 'batchSendReview'
        },
        {
          label: '加送',
          name: 'batchSend',
          kind: 'error', // error
          type: 'request',
          method: 'post',
          data: {
            paperIdList: '("{parentId}").split(",")',
            receiveUnitUserId: '{userId}',
            extSendFlag: '1'
          },
          addr: 'batchSendReview'
        }
      ]
    }
  ]
}
export default BatchSendUnit



// WEBPACK FOOTER //
// ./src/layout/regularPage/config/thesisManage/batchSendUnit.js